import PublicationImage from './PublicationImage';


export default PublicationImage;
